(function (appComponents) {

	appComponents.services.whereToBuy = function (Components) {

		var whereToBuy = {};

		whereToBuy.name = "whereToBuy";


		Components.getComponentPrototype().extend(whereToBuy);

		whereToBuy._helpers = whereToBuy._getService("helpers");
		whereToBuy._modals = whereToBuy._getService("modals");

		var pagesWhereToHide = ["mvmOverview", "mvMotorDetails"];

		whereToBuy.elements = {
			get addressSection() {
				return $("[pc-container='where-to-buy--address-section']");
			},
			get googleMap() {
				return $("[pc-container='where-to-buy--map-canvas']")[0];
			},
			get searchForm() {
				return $("[pc-container='where-to-buy--search-form']");
			},
			get whereToBuyBtn() {
				return $("[pc-container='where-to-buy--show-modal-btn']");
			}
		};

		whereToBuy.bindings = function () {
			$(whereToBuy._elements.body).on("click", "[pc-container='where-to-buy--show-modal-btn']", function (e) {
				// ping and init
				setTimeout(function () {
					whereToBuy.handlers.onMapModalShow();
					$("#wby-country").select2();
					$("#wby-country").val("US").trigger("change");
					$("#wby-radius").val("50").trigger("change");
				}, 100);
			});
			$(whereToBuy._elements.body).on("click", "[pc-container='where-to-buy--more-stores-btn']", function (e){
				console.log("here in js....");
				whereToBuy.handlers.onShowMoreStores();
			})

		$(".submit_locator").on("click", function(e){
			console.log("store locater submit");
			$('input[name="posLatitude"]').val("");
			$('input[name="posLongitude"]').val("");
			//alert($('input[name="posLatitude"]').val(), $('input[name="posLongitude"]').val());
			whereToBuy.handlers.onSearchStoresSubmit(true);
			return false;
		});
			
			$(document).on('click','#fetchLocation', function (e){
				
				navigator.geolocation.getCurrentPosition(
				function (position)
				{
				$('input[name="posLatitude"]').val(position.coords.latitude);
				$('input[name="posLongitude"]').val(position.coords.longitude);	
					//alert($('input[name="posLatitude"]').val()+" "+ $('input[name="posLongitude"]').val());
					whereToBuy.handlers.onSearchStoresSubmit(false);
					return false;
				},
				function (error)
				{
					//alert("An error occurred... The error code and message are: " + error.code + "/" + error.message);
					$("#error-search-wby").show();
					$("#search-error")[0].innerHTML = "User denied Geolocation";
					console.log(error.message);
					$('[pc-container="where-to-buy--address-section"]').hide();
					
				});
			});

			$(whereToBuy._elements.modals).on("click", "[pc-container='where-to-buy--more-stores-btn']", function (e) {
				whereToBuy.handlers.onShowMoreStores();
			});
			$("#close-wby").on("click", function(e){
				$("#error-field-wby").hide();
				$("#error-search-wby").hide();
			});
			$("#wby-country").on("select2:select",function(e){
				$("#wby-radius").val("50").trigger("change");
				whereToBuy.elements.searchForm.find('input:text').val('');
				$("#error-field-wby").hide();
				$("#error-search-wby ").hide();
			});
		};

		whereToBuy.map = null;
		whereToBuy.markers = [];
		whereToBuy.currentInfoWindow = null;
		whereToBuy.pageNumber = 1;
		whereToBuy.resultsPerPage = 2;

		whereToBuy.initMap = function () {
			// if (whereToBuy.map) return;
			var map = new google.maps.Map(whereToBuy.elements.googleMap, {
				zoom: 7
			});
			var defBounds = new google.maps.LatLngBounds();
			defBounds.extend(new google.maps.LatLng(38, -100));
			defBounds.extend(new google.maps.LatLng(58, -110));

			map.fitBounds(defBounds);
			whereToBuy.map = map;
		};

		whereToBuy.setMarkersAndBounds = function (geoData) {

			var bounds = new google.maps.LatLngBounds();

			var getMarker = function (item) {
				var itemLatLng = new google.maps.LatLng(item.geoPoint.latitude, item.geoPoint.longitude);
				var marker = new google.maps.Marker({
					position: itemLatLng,
					title: item.displayName
				});

				google.maps.event.addListener(marker, 'click', function () {
					var infowindow = new google.maps.InfoWindow({
						content: item.displayName + ": " + item.address.formattedAddress,
						position: itemLatLng,
					});
					if (whereToBuy.currentInfoWindow) whereToBuy.currentInfoWindow.close();
					infowindow.open(whereToBuy.map);
					whereToBuy.currentInfoWindow = infowindow;
				});
				return marker;
			};

			geoData.results.forEach(function (item) {
				var marker = getMarker(item);
				marker.setMap(whereToBuy.map);

				bounds.extend(marker.getPosition());

				whereToBuy.markers.push(marker);
			});

			whereToBuy.map.fitBounds(bounds);

			whereToBuy.pageNumber++;
		};

		whereToBuy.resetMap = function () {
			whereToBuy.markers.forEach(function (marker) {
				marker.setMap(null);
			});
			whereToBuy.markers.length = [];
			whereToBuy.pageNumber = 1;
		};

		whereToBuy.renderAddressStores = function () {
			var html = whereToBuy.templates.addressSection(whereToBuy.context);
			whereToBuy.elements.addressSection.html(html);
			//whereToBuy._applyScript.niceScroll();
		};

		whereToBuy.checkIfDisplayComponentNeeded = function () {
			if (pagesWhereToHide.indexOf(whereToBuy._page.title) > -1) {
				whereToBuy.elements.whereToBuyBtn.hide();
			} else {
				whereToBuy.elements.whereToBuyBtn.show();
			}
		};

		whereToBuy.handlers = {
			oncontrollerInitialized: function () {
				whereToBuy.checkIfDisplayComponentNeeded();
			},
			onSearchStoresSubmit: function (addressSearch) {
				if(addressSearch)
					{
				$("#error-search-wby").hide();
				//var hasErrors = whereToBuy._helpers.checkFormForErrors(whereToBuy.elements.searchForm);
				var hasErrors = whereToBuy._helpers.checkLocaterFormForErrors(whereToBuy.elements.searchForm);
				if (hasErrors) {
					return;
				}
					}
				whereToBuy.resetMap();
				var formData = whereToBuy._utils.getFormData(whereToBuy.elements.searchForm);
				//Added for storelocator
				var splitState = (formData.state).split("-");
				formData.state = splitState[1];
				if(formData.state == undefined){
					formData.state = "";
				}
				var city = formData.city;
				//city converted to correct format
				formData.city = city.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
				console.log("formData.city ===> ",formData.city);
				console.log("formData ==========> ",formData);
				formData.resultsPerPage = whereToBuy.resultsPerPage;
				formData.pageNumber = whereToBuy.pageNumber;
				whereToBuy._api.whereToBuy.getStoreLocations(formData).then(function (res) {
					if (res && res.status == 200) {
						whereToBuy.context.pager = res.body.pagination;
						whereToBuy.context.addresses = res.body.results;
						whereToBuy.setMarkersAndBounds(res.body);
						whereToBuy.renderAddressStores();
						$('[pc-container="where-to-buy--address-section"]').show();
					} else if (res.status == 210) {
						$("#error-search-wby").show();
						$("#search-error")[0].innerHTML = whereToBuy._messages.whereToBuyEmpty;
						whereToBuy.context.pager = res.body.pagination;
						whereToBuy.context.addresses = res.body.results;
						whereToBuy.renderAddressStores();
						$('[pc-container="where-to-buy--address-section"]').hide();
					} else {
						$("#error-search-wby").show();
						$("#search-error")[0].innerHTML = res.message;
						whereToBuy.context.pager = res.body.pagination;
						whereToBuy.context.addresses = res.body.results;
						
						whereToBuy.renderAddressStores();
						$('[pc-container="where-to-buy--address-section"]').hide();
					}
				}).fail(function (e) {
					console.log(e);
				});
			},
			onMapModalShow: function () {
				whereToBuy.initMap();
				whereToBuy.elements.addressSection.empty();
			},
			onShowMoreStores: function () {
				var formData = whereToBuy._utils.getFormData(whereToBuy.elements.searchForm);
				var splitState = (formData.state).split("-");
				formData.state = splitState[1];
				if(formData.state == undefined){
					formData.state = "";
				}
				//city converted to correct format
				var city = formData.city;
				formData.city = city.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
				console.log("formData.city ===> ",formData.city);
				formData.resultsPerPage = 50000;
				formData.pageNumber = 0;
				$("#error-search-wby").hide();
				whereToBuy._api.whereToBuy.getStoreLocations(formData).then(function (res) {
					if (res && res.status == 200) {
						whereToBuy.context.pager = res.body.pagination;
						whereToBuy.context.addresses = res.body.results;
						whereToBuy.setMarkersAndBounds(res.body);
						whereToBuy.renderAddressStores();
					}else if (res.status == 210) {
						$("#error-search-wby").show();
						$("#search-error")[0].innerHTML = whereToBuy._messages.whereToBuyEmpty;
					} else {
						$("#error-search-wby").show();
						$("#search-error")[0].innerHTML = res.message;
					}
				}).fail(function (e) {
					console.log(e);
				});
			}
		};


		whereToBuy.init = function () {
			whereToBuy._bindings();

			whereToBuy._events.registerHandler("controllerInitialized", whereToBuy.name, whereToBuy.handlers.oncontrollerInitialized);


		};


		return whereToBuy;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});